<div class="modal-header">
    <h5 class="modal-title">Vendor Note</h5>
    <button type="button" class="btn-close" (click)="dismiss()" aria-label="Close"></button>
</div>
<dirty-tracking [forms]="[noteForm]"></dirty-tracking>
<form novalidate #noteForm="ngForm" [ngClass]="{'was-validated': submitAttempt}">
    <div class="modal-body" *ngIf="noteInfo">
        <div class="row gx-3">
            <div class="col-md mb-3">
                <textarea rows="10" class="form-control form-control-lg" name="noteText"
                    [(ngModel)]="noteInfo.noteText"></textarea>
                <div class="invalid-feedback">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-black btn-round btn-lg" (click)="dismiss()"><i
                class="far fa-times"></i> Cancel</button>
        <button type="button" class="btn btn-secondary btn-round btn-lg" (click)="save()"><i class="far fa-check"></i>
            Save</button>
    </div>
</form>